import React, { useEffect, useMemo } from 'react';
import { SingleCommonType } from '../../types';
import { postAuthorTypePlaceholder } from '../../constants/placeholder';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { commonBackInfo } from '../../utils';
import useLanguage from '@op/hooks/useLanguage';

function getOrganization(value: string) {
  if (value === '-' || value === "" || !value) {
    return [];
  }

  return value.split('|');
}

export default function PostAuthorTypeSelect(props: SingleCommonType) {
  const { formatMessage } = useLanguage();
  const {
    onChange,
    changeOnCloseWindow,
    defaultValue,
    filterValue,
    defaultKey,
    oriDefaultFilter,
    lang,
  } = props;

  const options = useMemo(() => {
    return [
    {
      text: formatMessage('Official Account'),
      value: 'official',
    },
    {
      text: formatMessage('Earned Content - Partnered'),
      value: 'partnered',
    },
    {
      text: formatMessage('Earned Content - Organic'),
      value: 'earned',
    },
  ]
  }, [formatMessage]);

  const processedDefaultValue = useMemo(
    () => ({
      ...defaultValue,
      organization: getOrganization(defaultValue?.organization),
    }),
    [defaultValue],
  );

  const processedFilterValue = useMemo(
    () => ({
      ...filterValue,
      organization: getOrganization(filterValue?.organization),
    }),
    [filterValue],
  );

  const {
    selects: selectPostAuthorType,
    setSelects: setSelectPostAuthorType,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue: processedDefaultValue,
    filterValue: processedFilterValue,
    defaultKey: 'organization',
    oriDefaultFilter,
    options: options.map((item) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  function getCommonBackInfo() {
    const [text, isAll] = getButtonElement();
    return commonBackInfo(
      { organization: isAll ? '' : selectPostAuthorType.join('|') },
      { [defaultKey]: text },
      { isAll },
    );
  }

  useEffect(() => {
    onChange?.('organization', getCommonBackInfo());
  }, [selectPostAuthorType]);

  return (
    <div className={diffClassName}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={postAuthorTypePlaceholder[lang]}
        onClear={() => setSelectPostAuthorType([])}
        selectOptionsInfo={[selectPostAuthorType, setSelectPostAuthorType]}
        options={options}
        pointKey={FilterButtonPoint.postAuthorType}
        matchButtonWidth={false}
        showNumber={1}
        onChange={() => {
          const data = getCommonBackInfo();
          changeOnCloseWindow?.(data.value);
        }}
      />
    </div>
  );
}
